import { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { getLanguageFromPath } from "@/routing";

const LanguageRoute = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const urlLanguage = getLanguageFromPath(location.pathname);

    if (urlLanguage === "en" || urlLanguage === "fr") {
      if (i18n.language !== urlLanguage) {
        i18n.changeLanguage(urlLanguage);
      }
    }
  }, [location.pathname, i18n]);

  return <>{children}</>;
};

export default LanguageRoute;
